import axios from "axios";
import { CONFIG } from "../config/configs.js";
import { refreshToken_api } from "./auth";

let isRefreshing = false;

// Creating axios instance

const createAxios = (authenticated) => {
	const newInstance = axios.create({
		baseURL: CONFIG.API_URL_NEW,
		headers: {
			"Content-Type": "application/json",
		},
	});

	if (authenticated) {
		newInstance.interceptors.request.use(function (config) {
			const token = localStorage.getItem("token")
				? localStorage.getItem("token")
				: "";
			if (!config) {
				config = {};
			}
			if (!config.headers) {
				config.headers = {};
			}
			if (token) config.headers.Authorization = `Bearer ${token}`;
			config.withCredentials = true;
			return config;
		});

		newInstance.interceptors.response.use(
			(response) => {
				return response;
			},
			async (error) => {
				const originalRequest = error.config;
				if (
					error &&
					error.response &&
					error.response.status === 401 &&
					error?.response?.data?.errorCode === "UNAUTHENTICATED"
				) {
					originalRequest._retry = true;
					try {
						if (isRefreshing) return;
						isRefreshing = true;
						const newToken = await refreshToken_api();
						isRefreshing = false;
						localStorage.setItem("token", newToken?.data?.access_token);
						return newInstance(originalRequest);
					} catch (_error) {
						window.location.reload();
						localStorage.removeItem("token", "");
						localStorage.removeItem("accessToken", "");
						window.location.href = "/";
					}
				} else {
					return Promise.reject(error);
				}
			}
		);
	} else if (!authenticated) {
		newInstance.interceptors.request.use(function (config) {
			config.withCredentials = true;
			return config;
		});

		newInstance.interceptors.response.use(
			(response) => {
				return response;
			},
			(error) => {
				if (
					error &&
					error.response &&
					error.response.status === 401 &&
					error?.response?.data?.errorCode === "UNAUTHORIZED"
				) {
					window.location.reload();
					localStorage.removeItem("token", "");
					window.location.href = "/";
				} else {
					return Promise.reject(error);
				}
			}
		);
	}
	return newInstance;
};

export const authenticatedApi = createAxios(true);

export const unauthenticatedApi = createAxios(false);
